import { Notify } from 'quasar'

/**
 * Centralized API error handler.
 *
 * @param {string} context - Human-readable context (e.g. "[MissionDetail] Loading mission")
 * @param {object} [options]
 * @param {boolean} [options.silent=false] - Suppress user notification (log only)
 * @param {string} [options.fallbackMessage] - Custom error message
 * @param {boolean} [options.rethrow=false] - Rethrow error for caller chaining
 * @returns {Function} catch handler (error) => { ... }
 */
export function apiErrorHandler(context, options = {}) {
  const { silent = false, fallbackMessage, rethrow = false } = options

  return function (error) {
    // 1. Structured logging
    const detail = error.response?.data?.detail || error.response?.data || ''
    console.error(`${context}:`, error.message, detail)

    // 2. User notification
    if (!silent) {
      const message =
        fallbackMessage ||
        error.response?.data?.detail ||
        (error.response
          ? `Server-Fehler (${error.response.status})`
          : 'Netzwerk-Fehler – bitte Verbindung prüfen.')

      Notify.create({
        type: 'negative',
        message,
        position: 'top',
        timeout: 5000
      })
    }

    // 3. Optional rethrow for chaining
    if (rethrow) {
      return Promise.reject(error)
    }
  }
}
